module.exports = __webpack_public_path__ + "img/IMMUNOLOGY2026.4bfbcd53.jpg";